module.exports = __webpack_public_path__ + "img/1.20.2_Russian_road_sign.ae539c61.svg";